<template>
  <div>
    <div class="row existing">
      <div v-if="currentDefaultImage(type)" class="col-12">
        <div>
          <img :src="currentDefaultImage(type)" class="img-responsive" :alt="`default ${type} image`">
        </div>
        <button class="btn btn-ss-danger kt-btn--square" @click="deleteCurrentDefaultImage(type)">
          <i class="fa fa-trash" />Delete
        </button>
      </div>
    </div>

    <div v-if="! currentDefaultImage(type)" class="row uploader">
      <div class="default-image-cropper-container col-12">
        <div class="default-image-cropper-body">
          <cropper v-if="original_image"
                   classname="default-image-cropper"
                   :src="original_image.src"
                   :stencil-props="{
                     aspectRatio: 1/1,
                   }"
                   @change="updateCropped" />
          <div v-if="cropped_image" class="default-image-cropper-file-details">
            <p>{{ original_image.name }} ( {{ formatBytesAs(image_size, `MB`) }} )</p>
            <p>Original dimensions: {{ original_image.width }} x {{ original_image.height }}</p>
            <p>Cropped dimensions: {{ cropped_image.width }} x {{ cropped_image.height }}</p>
            <p>Images will be resized to up to 3000 x 3000</p>
          </div>
          <div class="form-group">
            <span class="btn btn-ss btn-file">
              Browse <input :id="`default-image-upload-${type}`"
                            :name="`default-image-upload-${type}`"
                            type="file"
                            @change="onFileChange">
            </span>
            <button class="btn btn-ss-standout" :disabled="!original_image" @click="upload">
              Upload
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Cropper } from 'vue-advanced-cropper';
import { formatBytesAs } from 'Helpers/formatters.js';

export default {
  components: {
    Cropper,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    original_image: null,
    original_image_size: 0,
    cropped_image: null,
    uploaded: '',
    valid: true,
  }),
  methods: {
    currentDefaultImage(type) {
      axios.post(`/default-image/exists`, {
        type,
      }).then((response) => {
        if (response.data.data.exists) {
          this.uploaded = true;
        }
      }).catch(() => null);
      if (this.uploaded) {
        return window.user[`default_image_path_${type}`];
      }
      return null;
    },

    updateCropped({ canvas }) {
      const img = new Image();
      img.src = canvas.toDataURL();
      img.onload = () => {
        this.cropped_image = img;
      };
    },
    formatBytesAs,
    deleteCurrentDefaultImage() {
      axios.delete(`/default-image?type=${this.type}`).then(() => {
        this.uploaded = null;
        toastr.success(`Default image for ${this.type} successfully deleted`);
      }).catch(() => {
        toastr.error(`Unable to delete ${this.type} image. Please try again later`);
      });
    },
    onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    createImage(file) {
      const reader = new FileReader();
      const self = this;
      self.valid = true;
      reader.onload = (e) => {
        // Initiate the JavaScript Image object.
        const image = new Image();
        // Set the Base64 string return from FileReader as source.
        image.src = e.target.result;
        const type = this.type;
        image.onload = function () {
          const chosen_file = document.querySelector(`#default-image-upload-${type}`).files[0];
          self.original_image = image;
          self.original_image.name = chosen_file.name;
          self.image_size = chosen_file.size;
        };
      };
      reader.readAsDataURL(file);
    },
    upload() {
      if (this.valid) {
        axios.post(`/default-image`, {
          image: this.cropped_image.src,
          type: this.type,
        }).then((response) => {
          toastr.success('Profile picture successfully uploaded.');
          if (response.data && response.data.data.image) {
            this.uploaded = response.data.data.image;
            window.user.default_image = this.uploaded;
          }
        }).catch(() => {
          toastr.error('Unable to upload. Please try again later');
        });
      } else {
        toastr.error('Image must be square.');
      }
    },
  },
};
</script>

<style scoped lang='scss'>
    @use "sass:map";

    @use "~AssetsSass/_variables.scss" as *;

    .uploader {
        img {
            /*max-height: 150px;*/
            width:100%;
            margin: 0 auto 20px auto;
        }

        .default-image-cropper-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;

          .default-image-cropper-header {
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .default-image-cropper-body {
            background-color: #323232;
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;
            .default-image-cropper {
              width: 65vw;
              height: auto;
              margin-bottom: 10px;
            }
            .default-image-cropper-file-details {
              color: #efefef;
              p {
                text-align: center;
              }
            }
            .form-group {
              margin: 15px;
              .btn-file {
                  position: relative;
                  overflow: hidden;
              }
              .btn-file input[type=file] {
                  position: absolute;
                  top: 0;
                  right: 0;
                  min-width: 100%;
                  min-height: 100%;
                  font-size: 100px;
                  text-align: right;
                  filter: alpha(opacity=0);
                  opacity: 0;
                  outline: none;
                  cursor: inherit;
                  display: block;
              }
            }
          }
        }
    }

    .existing {
        img {
            width:100%;
        }
        button {
            width:100%;
        }
    }
    .upload-button {
        button {
            margin-top:10px;
        }
    }

    .upload-placeholder {
        border: 2px dashed map.get($ss-adds, 'light-grey');
        max-width:100%;
        height:0;
        margin-bottom: 20px;
        padding-bottom: 100%;
        p {
            text-align:center;
            margin-top:45%;
        }
    }
</style>
